import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { DeepLinkService } from '../services/deep-link.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private deepLinkService: DeepLinkService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Check if user is fully authenticated (including PIN/FaceID)
    const isFullyAuth = this.authService.isFullyAuthenticated();
    if (!isFullyAuth) {
      // Store the intended destination with query params for after authentication
      const queryParams = route.queryParams;
      if (queryParams && Object.keys(queryParams).length > 0) {
        this.deepLinkService.storePendingDeepLink(state.url.split('?')[0], queryParams);
      }

      // Check if user has basic Cognito session but not fully authenticated
      const hasBasicAuth = this.authService.isLoggedIn();
      if (hasBasicAuth) {
        // User has Cognito session but hasn't completed PIN/FaceID, redirect to sign-in to complete flow
        this.router.navigate(['signin']);
      } else {
        // User has no authentication at all
        this.router.navigate(['signin']);
      }
    }
    return isFullyAuth;
  }
}
